var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBfidDrivingLicense(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9568 6.54572C30.7182 6.54572 32.9568 8.78429 32.9568 11.5457V24.4543C32.9568 27.2157 30.7182 29.4543 27.9568 29.4543L7.95679 29.4543C5.19537 29.4543 2.95679 27.2157 2.95679 24.4543V11.5457C2.95679 8.78429 5.19536 6.54572 7.95679 6.54572H27.9568Z",
    stroke: "#CACACA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2737 16.6357H28.7259",
    stroke: "#CACACA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2737 19.3643H26.2467",
    stroke: "#CACACA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.826 17.2966C14.4894 17.2966 15.8379 15.9047 15.8379 14.1877C15.8379 12.4706 14.4894 11.0787 12.826 11.0787C11.1627 11.0787 9.81421 12.4706 9.81421 14.1877C9.81421 15.9047 11.1627 17.2966 12.826 17.2966Z",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 24.2517C18 21.8453 15.6809 19.8991 12.8257 19.8991C9.97048 19.8991 7.65137 21.8453 7.65137 24.2517",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidDrivingLicense);
export default __webpack_public_path__ + "static/media/bfid-driving-license.94758c9eff651253b04506d070f549c4.svg";
export { ForwardRef as ReactComponent };